import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import KanBoIcon from 'components/KanBoIcon'
import User from 'components/User'
import UserContainer from 'components/ControlledUser'

export class HomeUser extends React.Component {
  renderUserComponent = ({
    intl,

    id,
    isActive,
    menu,
    currentUserRoles,
    mode,
    permissionLevel,
    onActivateUser,
    onDeactivateUser,
    onRolesClick,

    ...props
  }) => {
    const _menu = []
    if (currentUserRoles['role-manage'] && isActive) {
      _menu.push({
        icon: <KanBoIcon fixedWidth name='kanbo-16-user-role' />,
        title: <FormattedMessage id='USER_ROLES' />,
        onClick: () => onRolesClick(id)
      })
    }

    if (currentUserRoles['license-manage']) {
      if (isActive) {
        _menu.push({
          icon: <KanBoIcon fixedWidth name='kanbo-16-remove-responsible' />,
          title: <FormattedMessage id='USERS_DEACTIVATE' />,
          onClick: () => onDeactivateUser(id)
        })
      } else {
        _menu.push({
          icon: <KanBoIcon fixedWidth name='kanbo-16-set-responsible' />,
          title: <FormattedMessage id='USERS_ACTIVATE' />,
          onClick: () => onActivateUser(id)
        })
      }
    }

    return (
      <User
        {...props}
        id={id}
        isActive={isActive}
        listItem
        menu={_menu}
        defaultMenu
      />
    )
  }

  render () {
    return (
      <UserContainer
        {...this.props}
        presence
      >
        {this.renderUserComponent}
      </UserContainer>
    )
  }
}

export default injectIntl(HomeUser)
